export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1637_.2cdf9e48.jpg";